var n = ["vasárnap", "hétfőn", "kedden", "szerdán", "csütörtökön", "pénteken", "szombaton"];
function o(r) {
  return function(t) {
    var a = n[t.getUTCDay()], e = r ? "" : "'múlt' ";
    return "".concat(e, "'").concat(a, "' p'-kor'");
  };
}
var f = {
  lastWeek: o(!1),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: o(!0),
  other: "P"
}, c = function(t, a) {
  var e = f[t];
  return typeof e == "function" ? e(a) : e;
};
const k = c;
export {
  k as default
};
